import React, { useContext } from 'react';
import { StepSummaryForm } from './step-summary-types';
import { ProcessForm } from '../subject-requests-types';
import { UserContext } from '@eas/common-web';
import { SubjectRegistrationType } from '../../../models';

export function StepSummaryLabel({
  stepValues,
  allValues,
}: {
  stepValues?: StepSummaryForm;
  allValues?: ProcessForm;
}) {
  const { user } = useContext(UserContext);
  const state = getStateLabel(user, stepValues, allValues);
  return (
    <>
      Stav registrace: <b>{state}</b>
    </>
  );
}

const getStateLabel = (
  user: any,
  stepValues?: StepSummaryForm,
  allValues?: ProcessForm
) => {
  if (!stepValues?.isSent) {
    return 'NEODESLÁNO';
  }
  if (
    user?.hasNiaExternalId &&
    allValues?.type === SubjectRegistrationType.NATURAL_PERSON_REGISTRATION
  ) {
    return 'SCHVÁLENA';
  }
  // default
  return 'ČEKÁ NA AUTORIZACI';
};
